import { FormStore } from '@roc/feature-app-core';
import { GlobalStore } from '@roc/feature-app-core';
import { AppraisalsService } from '@roc/feature-appraisals';
import {
  generateUUID,
  parseAddress,
} from '@roc/feature-utils';
import { makeObservable, observable, override } from 'mobx';

export class PropertyFormStore extends FormStore {
  public loanSubType: string;

  key = generateUUID();
  isEditing = true;

  constructor(form, globalStore, loanSubType) {
    super(form, globalStore);
    this.loanSubType = loanSubType;
    this.prepopulateNewProperty();

    makeObservable(this, {
      key: observable,
      isEditing: observable,
      reset: override,
    });
  }

  reset() {
    super.reset();
    this.isEditing = true;
    this.form.meta.editMode = true;
    this.form.meta.key = this.key;
  }

  prepopulateNewProperty() {
    this.form.meta.key = generateUUID();
    this.form.meta.editMode = true;
  }
  setEditMode(value) {
    this.form.meta.editMode = value;
    this.isEditing = value;
  }
  saveAddressField(address: string, addressDetails, geometryDetails) {
    const parsedAddress = parseAddress(
      address,
      addressDetails,
      geometryDetails
    );

    const streetAddress =
      parsedAddress.street_number === null
        ? parsedAddress.street
        : parsedAddress.street_number + ' ' + parsedAddress.street;
    this.onFieldChange('address', streetAddress);
    this.onFieldChange('streetNumber', parsedAddress.street_number);
    this.onFieldChange('streetName', parsedAddress.street);
    this.onFieldChange('city', parsedAddress.city);
    this.onFieldChange('state', parsedAddress.state);
    this.onFieldChange('county', parsedAddress.county);
    this.onFieldChange('zipCode', parsedAddress.zip);
    this.onFieldChange('latitude', parsedAddress.latitude);
    this.onFieldChange('longitude', parsedAddress.longitude);
    this.onFieldChange('aptNumber', parsedAddress.aptNumber);
  }

  /**
   * Validates the property fields and cleans up unused fields (fields hidden because of other fields values)
   */
  validateAndCleanupProperty(excludedFields?: string[]) {
    this.cleanupUnusedFields();
    this.runFormValidation(excludedFields);

    return this.form.meta.isValid;
  }

  loadProperty(property) {
    this.loadForm({
      ...property,
      city: property?.city || '',
      state: property?.state || '',
      zipCode: property?.zipCode || '',
    });
    this.key = property.uuid;
  }

  getProperty() {
    const property = this.getFormValues();
    return {
      ...property,
      uuid: this.key,
    };
  }
  cleanupUnusedFields() {
    const property = this.getProperty();
    this.reset();
    this.loadForm(property);
  }


  onFieldChange(field, value) {
    super.onFieldChange(field, value);
    if (field == 'propertyOwnership') {
      if (value === false) {
        super.onFieldChange('purchaseDate', null);
        super.onFieldChange('outstandingLoanOnTheProperty', '');
        super.onFieldChange('payoffAmount', '');
        super.onFieldChange('cashOut', '');
        super.onFieldChange('renoBudget', '');
        super.onFieldChange('currentlyOccupied', false);
      }
    }
  }
}
